import dayjs from "dayjs";

import type { APIUserType } from "./APIUser";

export type APIAuthType = Partial<{
  access: string;
  refresh: string;
  token_type: "SuperAdmin";
  expires_in: number;
  user: APIUserType;
}>;
export interface IAuth {
  getToken(): string | undefined;
  getAuthorizationHeader(): string | undefined;
  getRefreshToken(): string | undefined;
  isValidToken(): boolean;
  getUser(): APIUserType | undefined;
  getAuth(): APIAuthType;
}

export class Auth implements IAuth {
  readonly data: APIAuthType;
  private readonly timestamp: number;
  constructor(data: APIAuthType) {
    this.data = data;
    this.timestamp = new Date().getTime();
  }
  getAuth(): APIAuthType {
    return this.data;
  }
  getToken(): string | undefined {
    return this.data.access;
  }
  getAuthorizationHeader(): string | undefined {
    if (!this.data.access) {
      return undefined;
    }
    return `${this.data.token_type ?? "SuperAdmin"} ${this.data.access}`;
  }
  getRefreshToken(): string | undefined {
    return this.data.refresh;
  }
  isValidToken(): boolean {
    return (
      !!this.data.access &&
      !!this.data.expires_in &&
      dayjs(this.timestamp).add(this.data.expires_in, "second").isAfter(dayjs())
    );
  }
  getUser(): APIUserType | undefined {
    return this.data.user;
  }
}
